module.exports = __webpack_public_path__ + "static/media/02.3cfdc72c.jpg";